export default function PressReleases() {
  const releases = [
    {
      date: 'March 15, 2024',
      category: 'Expansion',
      title: 'TrackVerse Opens State-of-the-Art Distribution Hub in Singapore',
      excerpt: 'TrackVerse announces the opening of its newest distribution hub in Singapore, strengthening its Asia-Pacific presence and reducing transit times by 25% for regional shipments. The 50,000 square meter facility features advanced automation and sustainable operations.',
      image: 'https://public.readdy.ai/ai/img_res/51af9ebb369787eef5efdc5ece2d40de.jpg'
    },
    {
      date: 'February 28, 2024',
      category: 'Technology',
      title: 'AI-Powered Route Optimization Reduces Delivery Times by 18%',
      excerpt: 'TrackVerse unveils its next-generation AI-powered route optimization system, leveraging machine learning algorithms to predict traffic patterns, weather conditions, and optimize delivery routes in real-time. Early results show an 18% reduction in average delivery times.',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20interface%20showing%20AI%20route%20optimization%20with%20glowing%20blue%20network%20lines%20connecting%20global%20map%20points%20data%20visualization%20screens%20in%20modern%20tech%20office%20clean%20professional%20technology%20photography&width=800&height=500&seq=press2&orientation=landscape'
    },
    {
      date: 'January 20, 2024',
      category: 'Sustainability',
      title: 'TrackVerse Launches Carbon-Neutral Shipping Options',
      excerpt: 'In line with global sustainability goals, TrackVerse introduces carbon-neutral shipping options across all service tiers. The initiative includes partnerships with eco-friendly carriers, electric vehicle fleets, and carbon offset programs to reduce environmental impact.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20electric%20delivery%20truck%20with%20green%20leaf%20logo%20parked%20in%20front%20of%20sustainable%20logistics%20facility%20with%20solar%20panels%20clean%20environment%20blue%20sky%20professional%20corporate%20photography&width=800&height=500&seq=press3&orientation=landscape'
    },
    {
      date: 'December 10, 2023',
      category: 'Milestone',
      title: 'TrackVerse Celebrates 1 Million Shipments Processed',
      excerpt: 'TrackVerse reaches a significant milestone, processing its 1 millionth shipment since founding in 2020. The achievement reflects the company\'s rapid growth and commitment to providing reliable logistics solutions to over 50,000 customers worldwide.',
      image: 'https://readdy.ai/api/search-image?query=Celebration%20scene%20in%20modern%20logistics%20office%20with%20diverse%20team%20members%20celebrating%20milestone%20achievement%20with%20confetti%20balloons%20professional%20corporate%20photography%20bright%20lighting%20happy%20atmosphere&width=800&height=500&seq=press4&orientation=landscape'
    },
    {
      date: 'November 5, 2023',
      category: 'Partnership',
      title: 'Strategic Partnership with Global Shipping Leaders Announced',
      excerpt: 'TrackVerse announces strategic partnerships with three major international shipping carriers, expanding service capabilities and providing customers with more routing options, competitive pricing, and enhanced delivery reliability across 50+ countries.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20between%20executives%20in%20modern%20corporate%20office%20with%20shipping%20containers%20visible%20through%20windows%20partnership%20agreement%20signing%20professional%20photography&width=800&height=500&seq=press5&orientation=landscape'
    },
    {
      date: 'October 18, 2023',
      category: 'Innovation',
      title: 'Real-Time GPS Tracking Now Available for All Shipment Types',
      excerpt: 'TrackVerse enhances its tracking platform with real-time GPS integration for all transport modes including road, sea, air, and rail. Customers can now monitor their shipments with minute-by-minute location updates and receive proactive delay notifications.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20GPS%20tracking%20map%20interface%20with%20delivery%20route%20and%20location%20pins%20clean%20professional%20product%20photography%20on%20white%20desk%20with%20laptop%20background%20technology&width=800&height=500&seq=press6&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Latest Press Releases
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Official announcements and news from TrackVerse
          </p>
        </div>

        <div className="space-y-8">
          {releases.map((release, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow"
            >
              <div className="md:flex">
                <div className="md:w-2/5">
                  <div className="w-full h-64 md:h-full bg-gray-100">
                    <img 
                      src={release.image}
                      alt={release.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                <div className="md:w-3/5 p-8">
                  <div className="flex items-center gap-4 mb-4">
                    <span className="text-sm text-gray-500">{release.date}</span>
                    <span className="px-3 py-1 bg-blue-100 text-blue-600 text-xs font-medium rounded-full">
                      {release.category}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {release.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {release.excerpt}
                  </p>
                  <button className="inline-flex items-center gap-2 text-blue-600 font-medium hover:text-blue-700 transition-colors">
                    Read Full Release
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
